import React, { useState, useEffect } from "react";
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Drawer,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import {
    Dashboard as DashboardIcon,
    Settings as SettingsIcon,
    Payment as PaymentIcon,
    LocalOffer as LocalOfferIcon,
    People as PeopleIcon,
    Person as PersonIcon,
    Assessment as AssessmentIcon,
    AccountBalanceWallet as AccountBalanceWalletIcon,
    Gavel as GavelIcon,
    Cancel as CancelIcon,
} from "@mui/icons-material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// import "./sidebar.css"; // Ensure this file exists or remove if not used

const menuItems = [

    { key: "Company", text: "Food & Beverages", icon: <DashboardIcon />, route: "/foodpramotions" },

    // { key: "Client_Management", text: "Catering & Services", icon: <RestaurantMenuIcon />, route: "/promotionscaterings" },
    // { key: "Settings_Controls", text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, route: "/promotionsgrocery" },
    // { key: "Order_Management", text: "Logistics & Supply", icon: <LocalShippingIcon />, route: "/logisticspromotions" },
];




const Promotionssidebar = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    // Media query for <= 1024px (for persistent variant)
    const isPersistentVariantScreen = useMediaQuery("(max-width:1024px)");

    // Media query for <= 1150px (for 180px width)
    const isNarrowerWidthScreen = useMediaQuery("(max-width:1250px)");

    // Determine drawer variant
    const drawerVariant = isPersistentVariantScreen ? "persistent" : "permanent";

    // Determine drawer width
    const drawerWidth = isNarrowerWidthScreen ? 180 : 215;

    const drawerOpenState = open;

    return (
        <>
            <Box
                sx={{
                    position: "fixed",
                    top: { xs: 80, md: 75 },
                    left: { xs: 12, md: 75 },
                    transition: "left 0.3s ease-in-out",
                    zIndex: 1301, // Ensure it's above the drawer when persistent and closed, but adjust as needed
                }}
                className="side-data-bar" // This class comes from your sidebar.css
            >
                <IconButton
                    onClick={() => setOpen(!open)}
                    sx={{
                        color: "#B276C3",
                        display: { xs: "flex", sm: "flex", md: "none" }, // 👈 hide on md+
                    }}
                >
                    <MenuIcon fontSize="large" />
                </IconButton>
            </Box>

            <Drawer
                anchor="left"
                variant={drawerVariant}
                open={drawerOpenState}
                onClose={isPersistentVariantScreen ? () => setOpen(false) : undefined}
                PaperProps={{
                    sx: {
                        width: drawerWidth, // Dynamically set width
                        marginTop: "92px",
                        overflowY: "auto", // Allow scrolling for the paper itself if content overflows height
                        height: "calc(100vh - 80px)",
                        borderRight: "0px solid #e0e0e0", // As per your last code, no visible border
                        backgroundColor: "#fff",
                        boxSizing: 'border-box',
                        transition: theme.transitions.create('width', { // Smooth width transition
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                        zIndex: 1300, // Default MUI Drawer z-index
                    },
                }}
            >
                <Box
                    className="re" // This class comes from your sidebar.css
                    sx={{
                        width: "100%", // Takes full width of the Paper
                        height: "100%",
                        overflowY: "auto",
                        padding: "0px 5px",
                        marginTop: { xs: "30px", sm: "30px", md: "1px" },
                        scrollbarWidth: "none", // For Firefox
                        '&::-webkit-scrollbar': { // For Chrome, Safari, Edge
                            display: 'none'
                        }
                    }}
                >
                    <List>
                        {menuItems.map((item, index) => (
                            <ListItem key={index} disablePadding>
                                <ListItemButton
                                    sx={{
                                        background: location.pathname === item.route ? "#A055B0" : "#B276C3",
                                        borderRadius: "20px",
                                        marginBottom: "10px",
                                        color: "#fff",
                                        "&:hover": { background: "#A055B0" },
                                        paddingY: "10px",
                                    }}
                                    onClick={() => {
                                        navigate(item.route);
                                        if (isPersistentVariantScreen) {
                                            setOpen(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon sx={{ color: "#fff", minWidth: '27px' }}>{item.icon}</ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        primaryTypographyProps={{ style: { fontSize: "12px", fontWeight: "bold" } }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default Promotionssidebar;










